import { TechRadarApi } from '@backstage-community/plugin-tech-radar';
import {
    RadarEntry,
    RadarEntrySnapshot,
    TechRadarLoaderResponse,
} from '@backstage-community/plugin-tech-radar-common';
import { DiscoveryApi, IdentityApi } from '@backstage/core-plugin-api';

export class TechRadarClient implements TechRadarApi {
    discoveryApi: DiscoveryApi;
    identityApi: IdentityApi;

    constructor(identityApi: IdentityApi, discoveryApi: DiscoveryApi) {
        this.identityApi = identityApi;
        this.discoveryApi = discoveryApi;
    }

    private async call(method: string, path: string): Promise<Response> {
        const result = await fetch(
            `${await this.discoveryApi.getBaseUrl('rtlDataPlugin')}/${path}`,
            {
                method: method,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${(await this.identityApi.getCredentials()).token}`,
                },
            },
        );
        return result;
    }

    async load(id: string | undefined): Promise<TechRadarLoaderResponse> {
        const path = id ? `techradar/${id}` : `techradar`;
        const result = (await this.call('GET', path).then(res =>
            res.json(),
        )) as TechRadarLoaderResponse;
        result.entries.forEach((entry: RadarEntry) =>
            entry.timeline.forEach(
                (timeline: RadarEntrySnapshot) =>
                    (timeline.date = new Date(timeline.date)),
            ),
        );
        return result;
    }
}
